import React, { useMemo, useState } from "react"
import { Select, Spin } from "antd"
import { useQuery } from "@tanstack/react-query"
import { request } from "../../utils/config"

// tog'a 1793 (2026-09-13): SHOFYOR tanlash — markaziy kartalar ro'yxatidan (GET Deliveries/Drivers).
// Tanlanganda onSelectRow orqali TO'LIQ karta (tel/transport/prava/texpasport) formaga avtomat tushadi.
// GET Users emas: u email'ni huquqsiz xodimga null qaytaradi, telefon/ismni umuman bermaydi.
const LOAD_DRIVERS = async () => {
  const r = await request({ url: "Deliveries/Drivers" })
  return r.data
}

type Props = {
  value?: number
  onChange?: (v: number | undefined) => void
  onSelectRow?: (row: any) => void
  placeholder?: string
}

export default function DriverSelect({ value, onChange, onSelectRow, placeholder }: Props) {
  const [q, setQ] = useState("")
  const { data, isFetching } = useQuery(["DRIVER_SELECT"], LOAD_DRIVERS, { staleTime: 0 })
  const rows: any[] = Array.isArray(data) ? data : data?.data || []
  const options = useMemo(
    () =>
      rows
        .filter((d) => !q || `${d.name || ""} ${d.lastname || ""} ${d.phone || ""} ${d.vehiclePlate || ""} ${d.vehicleInfo || ""}`.toLowerCase().includes(q.toLowerCase()))
        .map((d) => ({
          value: d.id,
          label: [[d.name, d.lastname].filter(Boolean).join(" "), d.phone, [d.vehicleInfo, d.vehiclePlate].filter(Boolean).join(" ")]
            .filter(Boolean)
            .join(" · "),
        })),
    [rows, q]
  )
  return (
    <Select
      size="large"
      allowClear
      showSearch
      style={{ width: "100%" }}
      placeholder={placeholder || "Водитель из списка"}
      value={value}
      onChange={(v) => {
        onChange?.(v as number | undefined)
        onSelectRow?.(rows.find((d) => d.id === v))
      }}
      onSearch={setQ}
      filterOption={false}
      notFoundContent={isFetching ? <Spin size="small" /> : "Водитель не найден — добавьте нового"}
      options={options}
    />
  )
}
